import React from 'react';
import CancelAction from './Actions/CancelAction';
import RescheduledAction from './Actions/RescheduleAction';

import { Can } from '../../../../_contexts/AbilitiesContext';

export default function ScheduledActions({ form }) {
  return <div>
    <Can I="reschedule" a="form">
      <RescheduledAction form={form} />
    </Can>
    &nbsp;
    <Can I="cancel" a="form">
      <CancelAction form={form} />
    </Can>
  </div>
}